import { CallLogsPage } from "./callLogs";

export const CallLogs = CallLogsPage;
